import { render, staticRenderFns } from "./VInventoryView.vue?vue&type=template&id=4fde0eb4"
import script from "./VInventoryView.vue?vue&type=script&lang=js"
export * from "./VInventoryView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports